import { render, staticRenderFns } from "./ExternalItemLink.vue?vue&type=template&id=56806c0b&"
import script from "./ExternalItemLink.vue?vue&type=script&lang=js&"
export * from "./ExternalItemLink.vue?vue&type=script&lang=js&"
import style0 from "./ExternalItemLink.vue?vue&type=style&index=0&id=56806c0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports